import { HTTP_REQUEST_METHOD } from '../constants/http-request-types.constant';

export class UrlConfig {
  constructor(
    public url: string,
    public method: string = HTTP_REQUEST_METHOD.GET,
    public extToken: boolean = false
  ) {}
}
